import { render, staticRenderFns } from "./BtnInserirCronogramaDesembolsoSebrae.vue?vue&type=template&id=72c7d4b4"
import script from "./BtnInserirCronogramaDesembolsoSebrae.vue?vue&type=script&lang=js"
export * from "./BtnInserirCronogramaDesembolsoSebrae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports